

import { DynamicScroller } from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

export default {
  name: 'SDynamicScroller',
  components: {
    DynamicScroller,
  },
  inheritAttrs: false,
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    isScrollable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scroller: null,
      content: null,
      containerIsScrolling: false,
    };
  },
  mounted() {
    this.scroller = this.$refs.scroller.$el;
    this.content = this.scroller.querySelector('.vue-recycle-scroller__item-wrapper');
    this.scroller.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    this.scroller.removeEventListener('scroll', this.onScroll);
    this.scroller = null;
  },
  methods: {
    onResize() {
      this.$emit('resize');
      this.setShadows();
      this.checkIsScrollable();
    },
    isVisible() {
      this.$emit('visible');
      this.setShadows();
    },
    onScroll(e) {
      this.$emit('scroll', e);
      if (!this.loading) {
        this.setShadows();
      }
    },
    setShadows() {
      if (!this.containerIsScrolling) {
        window.requestAnimationFrame(() => {
          if (this.scroller) {
            if (this.scroller.scrollTop > 0) {
              this.$refs.container.classList.add('off-top');
            } else {
              this.$refs.container.classList.remove('off-top');
            }

            if (Math.ceil(this.scroller.scrollTop) < (this.content.clientHeight - this.scroller.clientHeight)) {
              this.$refs.container.classList.add('off-bottom');
            } else {
              this.$refs.container.classList.remove('off-bottom');
            }
            this.containerIsScrolling = false;
          }
        });
        this.containerIsScrolling = true;
      }
    },
    scrollToPosition(position) {
      this.scroller?.scrollTo({
        left: 0,
        top: position,
        behavior: 'smooth',
      });
    },
    scrollToItem(index) {
      this.$refs.scroller?.scrollToItem(index);
    },
    scrollToBottom() {
      this.$refs.scroller?.scrollToBottom();
    },
    scrollTop() {
      return this.scroller?.scrollTop;
    },
    scrollHeight() {
      return this.scroller?.scrollHeight;
    },
    offsetHeight() {
      return this.scroller?.offsetHeight;
    },
    checkIsScrollable() {
      if (this.scrollHeight() - this.offsetHeight() > 0) {
        this.$emit('update:is-scrollable', true);
      } else {
        this.$emit('update:is-scrollable', false);
      }
    },
  },
};

